/* =================================================
   FLOATING CART BUTTON — state, pulse + pill badge
   Pairs with the markup at the bottom of layout/theme.liquid
   and assets/floating-cart.css.

   Why it watches the cart requests directly (Sep 2026):
   The header's original cart icon (#cart-icon-bubble) was
   removed when the floating cart replaced it. Dawn's cart
   page script (assets/cart.js) still tries to redraw that
   icon after a remove / quantity change, errors out because
   it's missing, and never sends its 'cart-update' event. So
   anything listening for that event (as this button used
   to) never hears about removals. Adds worked only because
   product-form.js sends its event before it hits the same
   missing icon.

   Instead, this file notices every request that changes the
   cart (add, change, update, clear) whichever script sends
   it, then asks Shopify for the real count. It doesn't rely
   on any other theme script finishing without errors.
   ================================================= */
(function () {
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?\/?$/;
  var nativeFetch = window.fetch;
  var latestRequest = 0;
  var refreshTimer = null;

  function isCartWrite(url) {
    try {
      return CART_WRITE.test(new URL(String(url), window.location.href).pathname);
    } catch (e) {
      return false;
    }
  }

  // Coalesces bursts (e.g. tapping + several times) into one lookup.
  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshFromServer, 60);
  }

  // Watch fetch() — used by Dawn's cart page, product form and quick add.
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var url = input && typeof input === 'object' && 'url' in input ? input.url : input;
      var request = nativeFetch.apply(this, arguments);
      if (isCartWrite(url)) {
        request.then(scheduleRefresh, function () {});
      }
      return request;
    };
  }

  // Watch XMLHttpRequest too, in case an app changes the cart that way.
  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartWrite(url)) {
      this.addEventListener('loadend', scheduleRefresh);
    }
    return nativeOpen.apply(this, arguments);
  };

  function cartJsUrl() {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return cartUrl.replace(/\/$/, '') + '.js';
  }

  function refreshFromServer() {
    var requestId = ++latestRequest;
    nativeFetch(cartJsUrl(), { cache: 'no-store', credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        // Ignore answers that arrive after a newer request was sent.
        if (requestId === latestRequest) updateFromCart(cart);
      })
      .catch(function () {});
  }

  var floatingCart, inner, bubble, number;
  var isHovering = false;

  function currentCount() {
    return parseInt(number.textContent, 10) || 0;
  }

  // Circle for 1 digit; for 2+ digits the badge widens into a pill
  // to fit the number. CSS animates the width change.
  function sizeBubble() {
    var digits = String(currentCount()).length;
    var width = 20;
    if (digits > 1) {
      width = Math.max(20, Math.ceil(number.getBoundingClientRect().width + 12));
    }
    bubble.style.width = width + 'px';
  }

  function pulse() {
    if (isHovering) return;
    inner.classList.remove('cart-pulse');
    void inner.offsetWidth; // restart cleanly even if a pulse is already mid-play
    inner.classList.add('cart-pulse');
  }

  function updateFromCart(cart) {
    if (!floatingCart) return;
    var count = cart.item_count || 0;
    var changed = count !== currentCount();
    number.textContent = count;
    floatingCart.classList.toggle('is-visible', count > 0);
    sizeBubble();
    if (changed && count > 0) pulse();
  }

  function init() {
    floatingCart = document.getElementById('floating-cart-button');
    if (!floatingCart) return;

    inner = floatingCart.querySelector('.floating-cart-inner');
    bubble = floatingCart.querySelector('.floating-cart-count');
    number = floatingCart.querySelector('.floating-cart-count-num');

    inner.addEventListener('mouseenter', function () {
      isHovering = true;
    });
    inner.addEventListener('mouseleave', function () {
      isHovering = false;
    });

    // If a cart change lands while the button is being hovered, the
    // pulse is skipped rather than fighting the hover scale.
    inner.addEventListener('animationend', function (e) {
      if (e.animationName === 'cart-pulse') {
        inner.classList.remove('cart-pulse');
      }
    });

    // Size the badge for the count Liquid rendered, again once the
    // Rubanok font has loaded, then switch on the width animation
    // (so the page never animates on load).
    sizeBubble();
    var fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    fontsReady.then(function () {
      sizeBubble();
      requestAnimationFrame(function () {
        bubble.classList.add('is-animated');
      });
    });

    // Mobile browsers restore pages from memory on Back; the cart
    // may have changed on another page since, so check again.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) refreshFromServer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
